// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorPage_errorMessage__-gnoL"};